import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { jobTraceIdResponseSchema } from '../schemas/job-trace-id-response.schema';

/**
 * Submists a password reset for filtered assets based on fleet info criteria.
 * @param params User Paged Collection Params
 * @param password New password to set
 * @param forcePasswordReset Force a password change on next login
 * @returns The job trace ID
 */
export function postBulkAssetPasswordReset(
  this: unknown,
  params: UserPagedCollectionParams,
  password: string,
  forcePasswordReset: boolean,
  assetIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).bulkAssetPasswordResetUrl()}?${params.urlParams}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({
            password,
            forcePasswordReset,
            assetIds: assetIds.length > 0 ? assetIds : undefined,
          }),
        }
      )
    )
  ).pipe(selectData(jobTraceIdResponseSchema));
}
